import type { ButtonHTMLAttributes, ReactNode } from 'react'
import styles from './IconButton.module.css'

export interface IconButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'aria-label'> {
  /** Required, not optional. An icon-only control with no accessible name is
   *  announced as "button" and is the single most common a11y defect in the
   *  app this replaces — making it a required prop moves that from a review
   *  comment to a compile error. */
  readonly label: string
  readonly size?: 'sm' | 'md'
  readonly children: ReactNode
}

export function IconButton({ label, size = 'md', type = 'button', children, ...rest }: IconButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      aria-label={label}
      title={label}
      className={[styles.iconButton, size === 'sm' ? styles.sm : ''].filter(Boolean).join(' ')}
    >
      <span aria-hidden="true">{children}</span>
    </button>
  )
}
